import { Assessment } from "./assessment";
import { InterventionLibrary } from "./intervention-library";
import { Methodology } from "./methodology";
import { Practice } from "./practice";

export { default as ProcurementLibrary } from "./ProcurementLibrary";
export const ProcurementPage = {
  Assessment,
  InterventionLibrary,
  Methodology,
  Practice,
};
